import * as t from "./actions";
import { StoreVisits as StoreVisitsConstants } from "./constants";

interface IMerchantProp {
  id: number;
  name: string;
  large_image_path: string;
  us_based?: boolean;
}
export module StoreVisits {
  export interface StoreVisitsContainerState {
    readonly merchantId: number;
    readonly publicationIds: number[];
    readonly startDate: string;
    readonly endDate: string;
    readonly topStoresData: StoreVisitsConstants.TopStoreData[];
  }
}

let initialState: StoreVisits.StoreVisitsContainerState = {
  merchantId: null,
  publicationIds: [],
  startDate: null,
  endDate: null,
  topStoresData: []
};

export default function (
  state = initialState,
  action: IPayload
): StoreVisits.StoreVisitsContainerState {
  switch (action.type) {
    case t.SET_MERCHANT_SELECTION:
      return (state = { ...state, merchantId: action.payload });

    case t.SET_PUBLICATION_SELECTION:
      return (state = { ...state, publicationIds: action.payload });

    case t.SET_START_DATE:
      return (state = { ...state, startDate: action.payload });

    case t.SET_END_DATE:
      return (state = { ...state, endDate: action.payload });

    case t.SET_TOP_STORES_DATA:
      return (state = { ...state, topStoresData: action.payload });

    case t.CLEAR_TOP_STORES_DATA:
      return (state = { ...state, topStoresData: [] });

    case t.GET_TOP_STORES_DATA_FAILURE:
    case t.GET_PUBLICATIONS_FAILURE:
    case t.GET_MERCHANTS_FAILURE:
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./client/modules/StoreVisits/reducer.ts